import commonStyles from '../styles.module.scss'
import {Modal, ButtonLink} from 'common/components'
import {useOpen} from 'common/hooks'
import {RequestDeclineForm, RequestStatus} from '..'

interface RequestDeclineProps {
  requestUuid: string
  requestStatus: RequestStatus
  disabled?: boolean
  tag?: 'variation' | 'default' | 'journal'
}

export default function RequestDecline({
  requestUuid,
  requestStatus,
  disabled,
  tag,
}: RequestDeclineProps) {
  const [isOpen, handleOpen, handleClose] = useOpen()

  const label = requestStatus === 'lending-manager-check' ? 'decline' : 'cancel'

  return (
    <>
      <div className={commonStyles.declineContent}>
        <ButtonLink
          danger
          className={commonStyles.declineButton}
          disabled={disabled}
          onClick={handleOpen}
        >
          {label}
        </ButtonLink>{' '}
        the request
      </div>
      <Modal
        width={486}
        title={`Request ${label}`}
        open={isOpen}
        onCancel={handleClose}
      >
        <RequestDeclineForm
          requestUuid={requestUuid}
          label={label}
          onClose={handleClose}
          tag={tag}
        />
      </Modal>
    </>
  )
}
